module.exports = __webpack_public_path__ + "static/img5-e779c8df33a29dec80459d99114d7a06.jpg";